new ScrollHint(".js-scroll");

// 各.js-case-sliderに対して独立したSwiperインスタンスを作成
document.querySelectorAll(".js-case-slider").forEach((slider) => {
  const config = {
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: false,
    breakpoints: {
      769: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        grid: {
          rows: 2,
          fill: "row",
        },
      },
    },
  };

  // navigation要素が存在する場合のみ設定を追加

  const sliderWrap = slider.closest(".p-case__sliderWrap");
  const nextEl = sliderWrap.querySelector(".swiper-button-next");
  const prevEl = sliderWrap.querySelector(".swiper-button-prev");
  if (nextEl && prevEl) {
    config.navigation = {
      nextEl: nextEl,
      prevEl: prevEl,
    };
  }

  new Swiper(slider, config);
});
